// extracted by mini-css-extract-plugin
export default {"root":"home_root__oL5uM","default":"home_default__4Plh3","hide":"home_hide__QLuxl","noWidth":"home_noWidth__sJMVA"};